module.exports = __webpack_public_path__ + "3432ab61291269d484458e3687041624.svg";